var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconArrowMenuRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 17.59 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.29 10.3a1 1 0 0 0 1.41 0l3.59-3.59a1 1 0 0 0 0-1.41L1.7 1.71A1 1 0 0 0 .29 3.12L3.17 6 .29 8.88a1 1 0 0 0 0 1.42M16.59 0h-11a1 1 0 0 0 0 2h11a1 1 0 0 0 1-1 1 1 0 0 0-1-1m1 6a1 1 0 0 0-1-1h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1m0 5a1 1 0 0 0-1-1h-11a1 1 0 0 0 0 2h11a1 1 0 0 0 1-1",
  className: "icon-arrow-menu-right_svg__cls-1"
})));
export default SvgIconArrowMenuRight;